/**
 * Constants for OTP email verification feature.
 * Centralized here for maintainability.
 */

/** Length of the OTP code (4 digits) */
export const OTP_LENGTH = 4

/** Cooldown period between resend attempts (in seconds) */
export const COOLDOWN_SECONDS = 60

/** Maximum number of verification attempts before requiring a new code */
export const MAX_ATTEMPTS = 10
